import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL; // cambia el puerto si tu backend usa otro (ej: 5000)

// 🔐 LOGIN
export const loginUser = async (email, password) => {
  const response = await axios.post(`${API_URL}/auth/login`, {
    email,
    password,
  });
  return response.data; // aquí viene { token, user }
};

// 👑 RUTA PROTEGIDA ADMIN
export const getAdminData = async (token) => {
  const response = await axios.get(`${API_URL}/users/admin`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};
